module.exports = __webpack_public_path__ + "img/layout_horizontal_s.7f7a633d.svg";